import Vue from "vue";
import Router from "vue-router";
import settings from "../settings";

import Layout from "@/containers/TheLayout.vue";
import {
  wrapRoutesWithRetry,
  isChunkLoadError,
} from "@/shared/retryImport";

/* Router Modules */
import authRouter from "./modules/auth";
import errorsRouter from "./modules/errors";

// Containers

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/upgrade-announcement",
    component: () => import("@/views/UpgradeAnnouncement"),
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        component: () => import("@/views/Index"),
        name: "Index",
        meta: {
          title: "首頁",
        },
      },
      {
        path: "/web/health",
        component: () => import("@/views/Health"),
        name: "Health",
      },
      {
        path: "/search/:keyword",
        component: () => import("@/views/SearchResult"),
        name: "SearchResult",
        meta: {
          title: "所有活動公告",
        },
      },
      {
        path: "/about",
        component: () => import("@/views/pages/About"),
        name: "About",
      },
      {
        path: "/activity/:id",
        component: () => import("@/views/Activity"),
        name: "Activity",
        meta: {
          title: "活動",
        },
      },
      {
        path: "/activityList/:type",
        component: () => import("@/views/ActivityList"),
        name: "ActivityList",
      },
      {
        path: "/newsList",
        component: () => import("@/views/NewsList"),
        name: "NewsList",
      },
      {
        path: "/news/:id",
        component: () => import("@/views/News"),
        name: "News",
      },
      {
        path: "/seat/:eventId/:sessionId",
        component: () => import("@/views/order/SelSt"),
        name: "SelSt",
        meta: {
          order: true,
        },
      },
      {
        path: "/confirmSeat/:eventId/:sessionId",
        component: () => import("@/views/order/ConfirmSt"),
        name: "ConfirmSt",
        meta: {
          order: true,
        },
      },
      {
        path: "/order/:eventId/:sessionId",
        component: () => import("@/views/order/Step1"),
        name: "Order1",
        meta: {
          order: true,
        },
      },
      {
        path: "/confirm/:eventId/:sessionId",
        component: () => import("@/views/order/Step2"),
        name: "Order2",
        meta: {
          order: true,
        },
      },
      {
        path: "/checkout/:eventId/:sessionId",
        component: () => import("@/views/order/Step3"),
        name: "Order3",
        meta: {
          order: true,
        },
      },
      {
        path: "/done/:orderId",
        component: () => import("@/views/order/Done"),
        name: "Done",
      },

      ...authRouter,
    ],
  },
  {
    path: "*",
    redirect: "/pages/404",
    hidden: true,
  },
];

// 為所有動態路由自動套用靜態分塊 (JS/CSS) 載入重試機制
wrapRoutesWithRetry(constantRoutes);

let routers = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: "history",
  // base: "/" + settings.publicPath,
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

// 全域捕捉 Chunk 載入終端失敗（經重試後仍失敗），提供強制重載兜底，防止白屏或卡死
routers.onError((error) => {
  if (isChunkLoadError(error)) {
    console.error("[Router] Chunk 載入重試後仍失敗，啟動頁面自我恢復:", error);
    try {
      const lastReload = sessionStorage.getItem("tp_chunk_reload_ts");
      const now = Date.now();
      // 15 秒內只自動刷新一次，防止硬性 404 或斷網時陷入無窮重載循環
      if (!lastReload || now - parseInt(lastReload, 10) > 15000) {
        sessionStorage.setItem("tp_chunk_reload_ts", String(now));
        window.location.reload(true);
      }
    } catch (e) {
      window.location.reload(true);
    }
  }
});

export default routers;

export const asyncRoutes = [
  /** When your routing table is too long, you can split it into small modules */
  errorsRouter,
  { path: "*", redirect: "/error/404", hidden: true },
];

wrapRoutesWithRetry(asyncRoutes);
